/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseDateFieldReminderTemplate = {
    SimpleReminderTemplate: 'DATE_FIELD_SIMPLE_REMINDER_TEMPLATE',
    EcardTemplate: 'DATE_FIELD_ECARD_TEMPLATE',
    BusinessCardTemplate: 'DATE_FIELD_BUSINESS_CARD_TEMPLATE'
} as const;
export type DatabaseDateFieldReminderTemplate = typeof DatabaseDateFieldReminderTemplate[keyof typeof DatabaseDateFieldReminderTemplate];


export function DatabaseDateFieldReminderTemplateFromJSON(json: any): DatabaseDateFieldReminderTemplate {
    return DatabaseDateFieldReminderTemplateFromJSONTyped(json, false);
}

export function DatabaseDateFieldReminderTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDateFieldReminderTemplate {
    return json as DatabaseDateFieldReminderTemplate;
}

export function DatabaseDateFieldReminderTemplateToJSON(value?: DatabaseDateFieldReminderTemplate | null): any {
    return value as any;
}

